module.exports = "/static/assets/89f0c7bda15efdcea10aeec140348916.png";